import { useRef, useEffect } from 'react'

import * as React from 'react'
import { classes, style as _style } from 'typestyle'

/* Hooks ======================================================================================== */
import useValue from '../../hooks/use-value'
import useBoolean from '../../hooks/use-boolean'

/* Styles ======================================================================================= */
import { selectorClass } from './selector.class'
import { buttonClass } from '../button/button.class'
import { w100 } from '../../styles/styleset/width/w100'

/* Styles ======================================================================================= */

/* Types ======================================================================================== */
type SelectorProps = {
  style?: React.CSSProperties
  children?: any
  className?: string
  shouldCoverOnSelect?: boolean
  horiz?: boolean
  spacing?: number
  selected?: number
  parentRef?: any
  fullWidth?: boolean
}

const SelectorItem = (props: any) => {
  const { handle, index, className, child } = props
  const ref = useRef(null)
  return (
    <div
      onClick={handle('click')(index, ref)}
      // onMouseOver={handle('mouseOver')(index)}
      className={className}
      ref={ref}
    >
      {child}
    </div>
  )
}

/* <Selector /> ================================================================================= */
// Need to implement shouldCover on select
const SelectorComponent: React.FC<SelectorProps> = props => {
  const { className, children, style, shouldCoverOnSelect, horiz, selected, fullWidth } = props
  const [hovered, $hovered] = useBoolean(false)
  const [hoveredKey, $hoveredKey] = useValue(-1)
  const [selectedKey, $selectedKey] = useValue(selected !== undefined ? selected : -1)
  const ref = useRef(null)

  useEffect(() => {
    React.Children.map(children, (item, key) => {
      if (item) {
        if ((item.props.highlight || item.props['data-highlight'] == true) && selectedKey === -1) {
          $selectedKey.set(key)
        }
      }
    })
  }, [children, selected])

  useEffect(() => {
    // $selectedKey.set(props.selected)
  }, [props.selected])

  const handle: any = (type: string) => {
    switch (type) {
      case 'click':
        return (key: number, ref: any) => () => {
          if ((ref?.current as any)?.getBoundingClientRect?.() && props.parentRef?.current) {
            const childRect = (ref?.current as any)?.getBoundingClientRect?.()
            const parentRect = props.parentRef?.current?.getBoundingClientRect()
            const left =
              props.parentRef?.current?.scrollLeft +
              childRect.left -
              parentRect.width -
              parentRect.x +
              parentRect.width
            ;(props.parentRef?.current as any).scrollTo({
              left: left - 40,
              behavior: 'smooth',
            })
          }
          $selectedKey.set(key)
        }
      case 'mouseOver':
        return (key: number) => () => {
          $hoveredKey.set(key)
          $hovered.set(true)
        }
      case 'mouseLeave':
        return () => {
          $hovered.set(false)
        }
    }
  }

  const getHoveredRect = () => {
    if (ref.current) {
      const parentRect = (ref.current as any).getBoundingClientRect()

      if (hoveredKey > -1 && (ref.current as any).childNodes[hoveredKey]) {
        const childRect = (ref.current as any).childNodes[hoveredKey].getBoundingClientRect()

        if (horiz) {
          return {
            top: childRect.top - parentRect.top,
            height: childRect.height,
            width: shouldCoverOnSelect ? '100%' : 3,
            right: 0,
            left: 'unset',
          }
        } else {
          return {
            width: childRect.width,
            left: childRect.left - parentRect.left,
          }
        }
      }
    }

    return {
      width: 0,
      left: 0,
    }
  }

  const {
    base,
    themed,
    childContainerBase,
    childContainerProped,
    childBase,
    childProped,
    hoverIndicatorBase,
    hoverIndicatorProped,
  } = selectorClass.setProps({
    horiz,
    shouldCoverOnSelect,
  })

  return (
    <div
      className={classes('aeki-selector', base, themed, className)}
      style={{
        ...style,
        display: 'flex',
      }}
      onMouseLeave={handle('mouseLeave')}
    >
      <div
        ref={ref}
        className={classes(
          childContainerBase,
          horiz && childContainerProped.horiz,
          fullWidth && w100,
        )}
      >
        {React.Children.map(children, (child, key) => {
          return (
            <SelectorItem
              handle={handle}
              index={key}
              className={classes(
                childBase,
                selectedKey === key && childProped.selected,
                buttonClass.names.baseAnimated,
                fullWidth && w100,
              )}
              child={child}
            />
          )
        })}
      </div>
      <div
        className={classes(
          hoverIndicatorBase,
          hovered && hoverIndicatorProped.hovered,
          shouldCoverOnSelect && hoverIndicatorProped.shouldCoverOnSelect,
        )}
        style={{ ...getHoveredRect() }}
      />
    </div>
  )
}

/* Export ======================================================================================= */
export const Selector = SelectorComponent
